module.exports = __webpack_public_path__ + "img/stock4.00d9580b.png";